<template>
  <div class="login-jump"></div>
</template>
<script>
import { getSsoAuthorityUrl } from '../../api/modules/user'
export default {
    name: "LoginJump",
    data() {
        return {}
    },
    created() {
        this.getAuthorityUrl()
    },
    methods: {
        async getAuthorityUrl() {
            let data = await getSsoAuthorityUrl()
            if (data) {
                window.location.replace(data)
            }
        }
    },
}
</script>